<div class="technical-error-container" *ngIf="showTechnicalErrorPageFound">
  <img src="assets/generalImage/404_error.svg" alt="mascot" />
  <h1 class="heading-8">{{'technical.error.title.1' | translate}}</h1>
  <app-button [textButton]="true" [buttonName]="'button.refresh'" (click)="reload()" class="submit-btn"></app-button>
</div>
